export const FBBCTheme = {
  name: "FBBC",
  goal: {
    "MUSCLE GAIN": "Muscle-Gain Phase",
    "FAT LOSS": "Fat-Loss Phase",
    "REVERSE DIETING": "Transition Phase",
    "MAINTENANCE": "Maintenance Phase",
  },
  color: {
    primary: "#0A73CE",
    secondary: "#FFC000",
		primaryGradient: "linear-gradient(#2B73FF, #0037B7)",
		logoBackground: "#333333",
    dark: "#000000",
    green: "#00ee46",
    highlight: "#232323",
  },
  font: {
    primary: "Roboto, sans-serif",
    secondary: "Roboto, sans-serif",
  },
  chat: {
    headerBackground: "#000000",
  },
  button: {
    background: "#FFC000",
    color: "#000000",
    borderRadius: "0px",
  },
  input: {
    background: "#FFFFFF",
    borderRadius: "0px",
  },
  tracker: {
    background: '#121212',
  }
};
